import { useLoadDocumentApiClient } from 'modules/Api';
import { useMutation } from 'react-query';
import { getFilenameFromContentDisposition } from 'services/fileUtils';
import type { UseMutationResult } from 'react-query';
import type { ErrorResponse } from 'modules/App/types';
import type { AxiosResponse } from 'axios';

type UseDownloadDocumentWithStamps = {
  clientOwnerId: EntityId;
  packageId: EntityId;
  documentId: EntityId;
};

type SignaturesResponseHeaders = {
  'content-disposition': string;
};

export default function useDownloadDocWithSignatures(): UseMutationResult<
  { file: Blob; fileName: string },
  ErrorResponse,
  UseDownloadDocumentWithStamps
> {
  const loadDocumentApi = useLoadDocumentApiClient();

  return useMutation<
    { file: Blob; fileName: string },
    ErrorResponse,
    UseDownloadDocumentWithStamps
  >(async ({ clientOwnerId, documentId, packageId }) => {
    const { data, headers } = (await loadDocumentApi.getDocumentWithStamps(
      packageId,
      documentId,
      clientOwnerId,
      {
        responseType: 'blob',
      }
    )) as AxiosResponse<Blob>;

    return {
      file: data,
      fileName: getFilenameFromContentDisposition(
        (headers as SignaturesResponseHeaders)['content-disposition']
      ),
    };
  });
}
